import React from 'react';
import { bool, node } from 'prop-types';
import styles from './style.module.scss';

const Page = ({ offset, children, ...props }) => (
  <div
    className={offset ? styles.page : null}
    {...props}
  >
    {children}
  </div>
);

Page.propTypes = {
  offset: bool,
  children: node.isRequired,
};

Page.defaultProps = { offset: false };

export default Page;
